//SMTWHFA
export const daysofweek = [
  { name: 'Mon', value: 'M', abbr: 'M' },
  { name: 'Tues', value: 'T', abbr: 'Tu' },
  { name: 'Weds', value: 'W', abbr: 'W' },
  { name: 'Thur', value: 'H', abbr: 'Th' },
  { name: 'Fri', value: 'F', abbr: 'F' },
];

export const getDayNames = (dayChars: string[]): string[] => {
  return dayChars.map((char) => {
    const day = daysofweek.find((d) => d.value === char);
    return day ? day.name : char;
  });
};

// Helper function to format time spans
export const formatTimeSpans = (
  timeSpans: {
    startHour: number;
    startMinute: number;
    endHour: number;
    endMinute: number;
    days: string;
  }[]
) => {
  return timeSpans.map((span) => {
    const startTime = `${String(span.startHour).padStart(2, '0')}:${String(
      span.startMinute
    ).padStart(2, '0')}`;
    const endTime = `${String(span.endHour).padStart(2, '0')}:${String(
      span.endMinute
    ).padStart(2, '0')}`;
    const days = span.days
      .split('')
      .map((day: string) => getDayNames([day])[0])
      .join(', ');
    return `${startTime}-${endTime} (${days})`;
  });
};
